export type TableTranslations = {
  pagination: {
    next: string;
    previous: string;
    totalPages: string;
    totalResults: string;
    of: string;
    navigation: string;
    rowsPerPage: string;
  };
};

export const tableTranslations: TableTranslations = {
  pagination: {
    next: 'Następna',
    previous: 'Poprzednia',
    totalPages: 'Stron',
    totalResults: 'Wyników',
    of: 'z',
    navigation: 'Nawigacja stron',
    rowsPerPage: 'Wierszy na stronę:',
  },
};
